import type { GenderType, RelatedPeopleStatusType } from '@shared/constants/constants';

export const RelatedPersonType = {
  ALL: 'ALL',
  CAREGIVERS: 'CG',
  CHILDREN: 'CH',
  FAMILY_AND_FRIEND: 'FH',
} as const;

export type RelatedPersonTypeType = (typeof RelatedPersonType)[keyof typeof RelatedPersonType];

export const RelatedPersonProfilePhotoType = {
  BASE64: 'Base64',
  URL: 'Url',
} as const;

export interface GetRelatedPeoplePayload {
  RelatedPersonType: RelatedPersonTypeType;
  Sort: 0 | 1;
}

export interface GetRelatedPeopleResult {
  Caregivers?: RelatedPersonProfile[];
  Children?: RelatedPersonProfile[];
  FamilyAndFriend?: RelatedPersonProfile[];
}

export interface RelatedPersonProfile {
  Age?: null | number;
  DataSource?: null | string;
  DisplayAge?: string;
  DisplayName: string;
  Email?: null | string;
  FlowType?: FlowType;
  Gender?: GenderType;
  Id: string;
  IsMyChartSync?: boolean | null;
  IsShowUpdateHealthRecord?: boolean;
  MaskedNric: string;
  Photo: RelatedPersonProfilePhoto;
  Prn: string;
  RelationShip: string;
  RequesterFullName?: null | string;
  Status: RelatedPeopleStatusType;
}

export interface RelatedPersonProfilePhoto {
  ContentType?: null | string;
  Data: null | string;
  Type: null | RelatedPersonProfilePhotoTypeType;
}

type FlowType = Omit<RelatedPersonTypeType, 'ALL'>;

type RelatedPersonProfilePhotoTypeType =
  (typeof RelatedPersonProfilePhotoType)[keyof typeof RelatedPersonProfilePhotoType];
